import { Component } from '@angular/core';
import { AuthenticationService } from '../../../../services/auth/authentication.service';

@Component({ standalone: false, selector: 'app-mostrar',
  templateUrl: './mostrar.component.html',
  styleUrls: ['./mostrar.component.scss']
})
export class MostrarComponent {

  constructor(public authService: AuthenticationService) { }

}
